import { use } from 'react';
import { ViewerContext } from 'app/agriculture/contexts/ViewerContext/ViewerContext';

export function useViewerContext() {
    const context = use(ViewerContext);

    if (context == null) {
        throw new Error('ViewerContext has not been provided');
    }

    return context;
}
